// Watches for "near the bottom" of a scroll container and fires the handler.
// If the bound element is itself scrollable (overflow-y: scroll|auto + scrollable
// content), it listens on that element. Otherwise it falls back to the window —
// the skill list, employee list, etc. render their rows inside a fixed-height
// scrollable div, so window-only listening would never fire.
export default {
  inserted(el, binding) {
    const { handler, disabled = false, distance = 150 } = binding.value || {};
    if (typeof handler !== "function") return;

    const isElementScrollable = () => {
      const s = getComputedStyle(el);
      if (s.overflowY !== "scroll" && s.overflowY !== "auto") return false;
      return el.scrollHeight > el.clientHeight;
    };

    let ticking = false;

    const onScroll = () => {
      if (disabled) return;
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(() => {
        let isAtBottom;

        if (isElementScrollable()) {
          isAtBottom =
            el.scrollTop + el.clientHeight >= el.scrollHeight - distance;
        } else {
          const scrollTop = window.scrollY || window.pageYOffset;
          const windowHeight = window.innerHeight;
          const docHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.offsetHeight,
            document.body.clientHeight,
            document.documentElement.clientHeight
          );
          isAtBottom = scrollTop + windowHeight >= docHeight - distance;
        }

        if (isAtBottom) {
          handler("bottom");
        }

        ticking = false;
      });
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("scroll", onScroll, { passive: true });

    el._checkScroll = onScroll;
    el._onScroll = onScroll;
  },

  unbind(el) {
    if (el._onScroll) {
      el.removeEventListener("scroll", el._onScroll);
      window.removeEventListener("scroll", el._onScroll);
    }
    delete el._onScroll;
    delete el._checkScroll;
  }
};
